import { render, staticRenderFns } from "./EvolutionDisplay.vue?vue&type=template&id=298434c4"
import script from "./EvolutionDisplay.vue?vue&type=script&lang=js"
export * from "./EvolutionDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports